import { useState, useEffect, FC } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import Popup from "@components/popup";

interface Modal {
    showModal: boolean; 
    setShowModal: any;
    info?: any;
}

export const Create:FC<Modal> = ({ showModal, setShowModal }) => {
    const { t } = useTranslation();

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        axios.post(`${import.meta.env.VITE_API_ADM_URL}/pay/expenses`, formData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('authToken')
            }
        }).then(_ => {       
            event.target.reset();
            toast.success("Расход добавлен");
            setShowModal(false);
        }).catch(_ => {
            toast.error(t('gtm.err'));
        });
    };
  
    return (
        <Popup showPopup={showModal} setShowPopup={setShowModal}>
            <h5 style={{ fontSize: '17px', marginBottom: 10, marginTop: 0 }}>Добавить расход</h5>

            <form onSubmit={handleSubmit}>
                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Тип</label>
                    <select name="type">
                        <option value={0}>Уплата налога</option>
                        <option value={1}>Пени, штрафы</option>
                        <option value={2}>Комиссия за эквайринг</option>
                        <option value={3}>Обслуживание серверов GTM</option>
                        <option value={4}>Обслуживание платформы</option>
                        <option value={5}>Иное</option>
                    </select>
                </div>

                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Назначение расхода</label>
                    <input placeholder="Назначение расхода" name="event" />
                </div>

                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Сумма расхода</label>
                    <input placeholder="Сумма расхода" type="number" name="value" />
                </div>

                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Дата расхода</label>
                    <input placeholder="Сумма расхода" type="date" name="date" />
                </div>

                <button style={{ background: "#6258ee", width: '100%' }} className="btn" type="submit">Добавить расход</button>
            </form>
        </Popup>
    );
}

export const Edit:FC<Modal> = ({ showModal, setShowModal, info }) => {
    const { t } = useTranslation();

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        formData.append('id', info.id);
        
        axios.post(`${import.meta.env.VITE_API_ADM_URL}/pay/expense`, formData, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('authToken')
            }
        }).then(_ => {       
            event.target.reset();
            toast.success("Расход обновлен");
            setShowModal(false);
        }).catch(_ => {
            toast.error(t('gtm.err'));
        });
    };
  
    return (
        <Popup showPopup={showModal} setShowPopup={setShowModal}>
            <h5 style={{ fontSize: '17px', marginBottom: 10, marginTop: 0 }}>Обновить расход</h5>

            <form onSubmit={handleSubmit}>
                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Тип</label>
                    <select name="type" defaultValue={info.type}>
                        <option value={0} selected={info.type === 0}>Уплата налога</option>
                        <option value={1} selected={info.type === 1}>Пени, штрафы</option>
                        <option value={2} selected={info.type === 2}>Комиссия за эквайринг</option>
                        <option value={3} selected={info.type === 3}>Обслуживание серверов GTM</option>
                        <option value={4} selected={info.type === 4}>Обслуживание платформы</option>
                        <option value={5} selected={info.type === 5}>Иное</option>
                    </select>
                </div>

                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Назначение расхода</label>
                    <input placeholder="Назначение расхода" name="event" defaultValue={info.event} />
                </div>

                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Сумма расхода</label>
                    <input placeholder="Сумма расхода" type="number" name="value" defaultValue={info.value} />
                </div>

                <div className={css.inputBlock} style={{ marginBottom: 10 }}>
                    <label style={{fontSize: "14px",color: "var(--text-color)", marginBottom: 0 }}>Дата расхода</label>
                    <input placeholder="Сумма расхода" type="date" name="date" defaultValue={info.date} />
                </div>

                <button style={{ background: "#6258ee", width: '100%' }} className="btn" type="submit">Обновить расход</button>
            </form>
        </Popup>
    );
}